import {ReactNode} from "react";
import {BadgeVariant} from "@interstate/components/Badge";
import {
  ArrowPathIcon,
  ArrowTopRightOnSquareIcon,
  BuildingOfficeIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  NoSymbolIcon,
  XCircleIcon
} from "@interstate/components/Icons";
import {InterstateToken} from "../../../../../lib/interstate";
import {BadgeMetadata} from "../../../../../badges";
import {SpinnerIcon} from "../../../../../icons";
import {CreateResultNode} from "../../view-model";

const variantForNode = (node: CreateResultNode): BadgeVariant => {
  switch (node.status) {
    case "queued":
      return "transparent";
    case "in-progress":
      return "info";
    case "created":
      return "success";
    case "operational":
      return "transparent";
    case "skipped":
      return "info";
    case "failed":
      return "error";
  }
};

const startIconForNode = (
  token: InterstateToken,
  node: CreateResultNode
): ReactNode | undefined => {
  switch (node.status) {
    case "queued":
      return <ArrowPathIcon />;
    case "in-progress":
      return <SpinnerIcon />;
    case "created":
      return <BuildingOfficeIcon />;
    case "operational":
      return (
        <CheckCircleIcon color={token("sem.color.on-surface.success.muted")} />
      );
    case "skipped":
      return node.message ? <InformationCircleIcon /> : <NoSymbolIcon />;
    case "failed":
      return node.message ? <InformationCircleIcon /> : <XCircleIcon />;
  }
};

const endIconForNode = (node: CreateResultNode): ReactNode | undefined => {
  switch (node.status) {
    case "created":
      return <ArrowTopRightOnSquareIcon />;
  }
};

export const resultNodeBadgeMetadata = (
  token: InterstateToken,
  node: CreateResultNode
): BadgeMetadata => {
  return {
    labelKey: `create-operational-hierarchy.result-states.${node.status}`,
    variant: variantForNode(node),
    startIcon: startIconForNode(token, node),
    endIcon: endIconForNode(node)
  };
};
